import React, { useState } from "react";

import TextInput from "./TextInput";
import APP_CONFIG from "../../APP_CONFIG";

let SHOW_ICON = <img src={APP_CONFIG.IMAGES.SHOW_HIDE_ICON} height={"20px"} width={"20px"} />;
let HIDE_ICON = <img src={APP_CONFIG.IMAGES.SHOW_EYE_ICON} height={"20px"} width={"20px"} />;

let TYPE_PASSWORD = "password";
let TYPE_TEXT = "text";

const PasswordInput = ({ type, passwordInputClass, className, ...rest }) => {
    const [customType, setCustomType] = useState(TYPE_PASSWORD);

    const handlePasswordToggle = () => {
        if (customType == TYPE_TEXT) {
            setCustomType(TYPE_PASSWORD);
        } else {
            setCustomType(TYPE_TEXT);
        }
    };
    return (
        <>
            <TextInput
                type={customType}
                inputClasses={`input-icon-padding ${passwordInputClass}`}
                className={className}
                {...rest}
            >
                <div className="input-icon cursor-pointer" onClick={handlePasswordToggle}>
                    {customType == TYPE_PASSWORD ? SHOW_ICON : HIDE_ICON}
                </div>
            </TextInput>
        </>
    );
};

export default PasswordInput;
